<template>
  <section id="contact" class="card background-opacity text-white p-5 container">
    <div class="row justify-content-center align-items-center">
      <h1 class="orbitron-font text-title mb-5" style="margin-bottom: 5dvh">Do you want to be closer to us?</h1>

      <!-- Columna Izquierda -->
      <div class="col-lg-6 col-md-12 text-center text-lg-start">
        <h1 class="text-subtitle orbitron-font text-center my-3">Contact Us</h1>
        <p class="fs-5 text-center">
          At IA Analytics, we provide
          <span class="text-neon oswald-font">innovative AI solutions tailored to your business.</span>
          From predictive analytics to automation, we optimize your processes with reliable and scalable tools. Contact us to drive your growth!
        </p>
        <img class="img-fluid d-block mx-auto mb-3 mb-lg-4" src="/images/logos/BarLogo.png" alt="AI Alpha Analytics Logo" style="width: 50%" />
      </div>

      <!-- Columna Derecha -->
      <div class="col-lg-6 col-md-12">
        <p class="fs-6 text-center">
          If you want to contact us, send us an email to
          <span class="text-neon oswald-font">contact@aialphaanalytics.com</span>
          or answer the form on the bottom
        </p>
        <form @submit.prevent="sendEmail" class="d-flex flex-column">
          <div class="mb-3">
            <input type="text" class="form-control" placeholder="Name" v-model="contactData.name" required />
          </div>
          <div class="mb-3">
            <div class="d-flex align-items-center">
              <input type="email" class="form-control" placeholder="Email" v-model="contactData.email" required />
            </div>
          </div>
          <div class="mb-3">
            <input type="text" class="form-control" placeholder="Subject" v-model="contactData.subject" required />
          </div>
          <div class="mb-3">
            <textarea class="form-control" placeholder="Message" v-model="contactData.message" required rows="4"></textarea>
          </div>
          <button :disabled="sendingEmail" type="submit" class="btn btn-neon btn-ocultar mx-5 mb-5">{{ sendingEmail ? 'Sending...' : 'Send' }}</button>
        </form>
      </div>
    </div>
  </section>
  <section id="rrss" class="m-0">
    <div class="contact-section mt-5 mb-4">
      <div class="container px-4 px-lg-5">
        <div class="row gx-4 gx-lg-5 justify-content-center">
          <div class="col-md-4 mb-3">
            <div class="card py-4 px-4 h-100 background-opacity">
              <div class="card-body text-center text-white oswald-font">
                <i class="fas fs-1 fa-map-marked-alt text-neon mb-2"></i>
                <h4 class="text-uppercase m-0">Address</h4>
                <hr class="my-4 mx-auto" />
                <div class="large">Viña del Mar, Valparaíso, Chile</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="card py-4 px-2 h-100 background-opacity">
              <div class="card-body text-center text-white oswald-font mx-0">
                <i class="fas fs-1 fa-envelope text-neon mb-2"></i>
                <h4 class="text-uppercase m-0">Email</h4>
                <hr class="my-4 mx-auto" />
                <a class="link-custom main anim-down" href="mailto:contact@aialphaanalytics.com"> contact@aialphaanalytics.com </a>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="card py-4 px-4 h-100 background-opacity">
              <div class="card-body text-center text-white oswald-font">
                <i class="fas fs-1 fa-mobile-alt text-neon mb-2"></i>
                <h4 class="text-uppercase m-0">Contact Number</h4>
                <hr class="my-4 mx-auto" />
                <div class="large">+569 65987845</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin.js';
import emailjs from '@emailjs/browser';

export default {
  mixins: [GlobalMixin],
  name: 'Contacto',
  data() {
    return {
      contactData: {
        name: null,
        email: null,
        phone: null,
        subject: null,
        message: null,
      },
      sendingEmail: false,
    };
  },
  methods: {
    async sendEmail() {
      this.sendingEmail = true;
      try {
        const emailData = {
          product: 'Landing AI Analytics',
          productDescription: 'AI Alpha Analytics Digital Business Card',
          reason: `We are ${this.contactData.name} and we are interested in working with AI Alpha Analytics`,
          full_name: this.contactData.name,
          email: this.contactData.email,
          phone_number: this.contactData.phone ? this.contactData.phone : '*Not provided.',
          subject: this.contactData.subject,
          message: this.contactData.message,
        };
        const response = await emailjs.send('service_vf717jm', 'template_7uy6eod', emailData, 'AhHSPIHWYy70OBWvF');
        this.toast('success', 'Email sent succesfully!');
      } catch (e) {
        console.log('Error: ', e);
        this.toast('error', 'Error sending email. Please try again later.');
      } finally {
        this.sendingEmail = false;
        this.contactData = {
          name: null,
          email: null,
          phone: null,
          subject: null,
          message: null,
        };
      }
    },
  },
};
</script>
